export default __webpack_public_path__ + "static/media/header.3283a97f.jpg";